// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3uh0Q","footer":"ModalInfo_footer__2Hjn8"};